package com.taager.dukan.feature.quicklink

sealed class QuickLinkSideEffect {
    object GoToHome : QuickLinkSideEffect()
    data class OpenMailTo(val email: String) : QuickLinkSideEffect()
}
